<template>
    <h2>{{$t('managePatients')}}</h2>
  </template>
  
  <script>
  export default {
      name: 'ortho-patients'
  }
  </script>
  
  <style>
  
  </style>
  